import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { getMinimumWageRules } from "./getMinimumWageRules/getMinimumWageRules";
import { getViolations } from "./getViolations/getViolations";

export class RizzoClient extends AbstractApiClient {
  public readonly getViolations = getViolations(this.Instance);
  public readonly getMinimumWageRules = getMinimumWageRules(this.Instance);
}
